import { useQuery } from "@tanstack/react-query";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { integrationQueryKeys } from "@/integration/data/integrationQueryKeys";

export default function useSlackChannels() {
  const { org } = useEnvironment();

  return useQuery({
    queryKey: integrationQueryKeys.slackChannels(org.id),

    queryFn: async () => {
      const res = await api.get<`/orgs/:orgId/slack/channels`>(
        `/orgs/${org.id}/slack/channels`,
      );
      return res.data;
    },

    retry: 2,

    select: (channels) =>
      (channels || []).map(({ id, name }) => ({
        id,
        name: `#${name}`,
      })),
  });
}
